import React from 'react'

const SomethingWentWrong: React.FC = () => {
  return (
    <div style={styles.container}>
      <h1 style={styles.heading}>
        Something went wrong, but don&apos;t worry!
      </h1>
      <p style={styles.message}>
        If you play a game with QR codes, please scan a code again, or if you
        play a geo-based game,
        <a href="/" style={styles.link}>
          &nbsp;click here to enter the code
        </a>
        .
      </p>
    </div>
  )
}

const styles: { [key: string]: React.CSSProperties } = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '20px',
    height: '100vh',
    textAlign: 'center',
    backgroundColor: '#f8f9fa',
    color: '#333',
  },
  heading: {
    fontSize: '24px',
    marginBottom: '20px',
  },
  message: {
    fontSize: '18px',
    lineHeight: '1.5',
  },
  link: {
    color: '#007bff',
    textDecoration: 'none',
    fontWeight: 'bold',
  },
}

export default SomethingWentWrong
